import { render, staticRenderFns } from "./List.vue?vue&type=template&id=353b8dd5&scoped=true"
import script from "./List.ts?vue&type=script&lang=ts&external"
export * from "./List.ts?vue&type=script&lang=ts&external"
import style0 from "./List.vue?vue&type=style&index=0&id=353b8dd5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353b8dd5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('353b8dd5')) {
      api.createRecord('353b8dd5', component.options)
    } else {
      api.reload('353b8dd5', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=353b8dd5&scoped=true", function () {
      api.rerender('353b8dd5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Masters/components/List/List.vue"
export default component.exports